import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Button, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { languageArray, radioColorSx, registrationTypeArray } from 'store/constant';
import HouseHoldStepper from './HouseHoldStepper';
import axiosInstance from 'custom-axios';
import { useParams } from 'react-router';

const rrCodeArray = ['F361', 'F362', 'F363', 'F364', 'F365', 'F366'];

const HouseHold = ({ setParentErrorStepIndex, parentErrorStepIndex, setActiveChildStep, activeChildStep, setActiveParentStep, activeParentStep, setFormData, formData }) => {

    const [houseHoldHomeComponent, setHouseHoldHomeComponent] = useState(false); // if false, then start from 1st
    // const [userData, setUserData] = useState([])
    const { id } = useParams();
    const loginType = localStorage.getItem('login_type');
    const methods = useForm({
        defaultValues: {
            household_name: '',
            household_language: '',
            rr_code: '',
            registration_type: '',
            role_options: [],
        },
    });

    const { register, control, getValues, watch, handleSubmit, setValue, reset, formState: { errors } } = methods;

    const hhName = watch('household_name') ?? '';

    const fetchUserAllPersonal = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-all-info/${id}`);

            if (response.personal_data) {
                // const roleOptionsArray = response.personal_data?.role_options?.split(',').map(option => parseInt(option));    
                methods.reset(response.personal_data);

                /*  Object.keys(response.personal_data).forEach((key) => {
                     setValue(key, response.personal_data[key]); // Set initial values dynamically
                 }); */
            }
        } catch (error) {
            console.error(error.message);
        }
    };

    const submitClientForm = () => {
        setHouseHoldHomeComponent(true)
        // then set child step make 0 to starting step from 0 
        setActiveChildStep(0)
    }

    useEffect(() => {
        // when client restart where he left then we need this, if its false it comes from starting of listing/household
        if (activeChildStep > 0 || loginType == 'client') {
            setHouseHoldHomeComponent(true);
        }

    }, [activeChildStep])

    useEffect(() => {
        fetchUserAllPersonal()
        // fetchUserData()
    }, [])


    return (
        <FormProvider {...methods}>

            {
                houseHoldHomeComponent ?
                    <HouseHoldStepper
                        activeChildStep={activeChildStep}
                        setActiveChildStep={setActiveChildStep}
                        setHouseHoldHomeComponent={setHouseHoldHomeComponent}
                        activeParentStep={activeParentStep}
                        setActiveParentStep={setActiveParentStep}
                        setParentErrorStepIndex={setParentErrorStepIndex}
                        parentErrorStepIndex={parentErrorStepIndex}
                    />
                    :
                    <>
                        <div style={{ backgroundColor: '#fff', padding: '0 35px 35px 35px' }}>
                            <form onSubmit={handleSubmit(submitClientForm)}>

                                <Grid container spacing={2}>
                                    {/* <Grid item xs={12}>
                                        <h6 className="text-center raintree-green-color font-weight500px">HouseHold</h6>
                                    </Grid> */}

                                    <Grid item xs={12}>
                                        <Typography component={'h3'} className='form-head-gray-title'>HouseHold</Typography>
                                    </Grid>

                                    <Grid item xs={3} className='text-right align-content-center'>
                                        <label htmlFor="household-name" className='font15px'>Household Name</label>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            label="Household Name"
                                            fullWidth
                                            size='small'
                                            {...register('household_name', {
                                                required: true
                                            })}
                                            error={Boolean(errors && errors['household_name'])}
                                            InputLabelProps={{ shrink: !!hhName }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}></Grid>


                                    <Grid item xs={3} className='text-right align-content-center'>
                                        <label htmlFor="p-language-radio-group" className='font15px'>Language</label>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl component="fieldset" error={Boolean(errors?.household_language)}>

                                            <Controller
                                                name="household_language"
                                                control={control}
                                                rules={{ required: "Please select a language" }}
                                                render={({ field }) => (
                                                    <RadioGroup
                                                        row
                                                        id="p-language-radio-group"
                                                        {...field}
                                                        value={field.value || ''}
                                                    >
                                                        {languageArray.map((row) => (
                                                            <FormControlLabel
                                                                key={row.value}
                                                                value={row.value}
                                                                control={<Radio sx={radioColorSx} />}
                                                                label={row.label}
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                )}
                                            />

                                            <FormHelperText>{errors?.household_language?.message}</FormHelperText>
                                        </FormControl>

                                    </Grid>

                                    <Grid item xs={3}></Grid>

                                    <Grid item xs={3} className='text-right align-content-center'>
                                        <label htmlFor="household_rr_code" className='font15px'>RR Code</label>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.rr_code)}>
                                            <InputLabel id="household_rr_code-label">RR Code</InputLabel>

                                            <Controller
                                                name="rr_code"
                                                control={control}
                                                defaultValue=""
                                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                    <Select
                                                        labelId="household_rr_code-label"
                                                        id="household_rr_code"
                                                        label="RR Code"
                                                        value={value}
                                                        onChange={(e) => {
                                                            onChange(e);
                                                        }}
                                                        classes={{ select: "custom-select-label" }}
                                                        MenuProps={{
                                                            disableScrollLock: true,
                                                            PaperProps: { sx: { maxHeight: 200 } },
                                                        }}
                                                    >
                                                        {rrCodeArray?.map((row, id) => (
                                                            <MenuItem key={id} value={row}>
                                                                {row}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}></Grid>

                                    <Grid item xs={3} className='text-right align-content-center'>
                                        <label htmlFor="registration_type" className='font15px'>Registration Type</label>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.registration_type)}>
                                            <InputLabel id="registration_type-label">Registration Type</InputLabel>

                                            <Controller
                                                name="registration_type"
                                                control={control}
                                                defaultValue=""
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        value={field.value ?? ''}
                                                        labelId="registration_type-label"
                                                        id="registration_type"
                                                        label="Registration Type"
                                                        MenuProps={{
                                                            disableScrollLock: true,
                                                            PaperProps: { sx: { maxHeight: 200 } },
                                                        }}
                                                    >
                                                        {registrationTypeArray?.map((row) => (
                                                            <MenuItem key={row.value} value={row.value}>
                                                                {row.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}></Grid>

                                    <Grid item xs={12} className='text-center'>
                                        <Button variant="contained" className='raintree-btn-green' type='submit'> Add Participant </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                    </>
            }
        </FormProvider>
    )
}

export default HouseHold